module Meevo.Plugins.Tippy {
    class TippyController extends Meevo.Components.CommonClasses.CommonControllerBase {
        // statically inject constructor resources
        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.tippyDataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "meevo.plugins.tippy.tippyService",
            "meevo.components.common.DataService"
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected tippyService: Meevo.Plugins.Tippy.TippyService,
            private meevoDataService: Meevo.Components.BaseClasses.IDataService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            $scope.$on(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT, (event, state, params) => {
                if (state.name == appSettings.ROUTE_NAMES.tippy && angular.isDefined(params)) {
                    this.processParams(params)
                }
            });

            this.createContext();
        }


        createContext(): void {
            let vm = this;
            vm.context = new TippyContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService,
                vm.loggingService, vm.securityService, vm.trackingService, this.$rootScope, vm.tippyService, vm.meevoDataService, vm.contextParams);

        }

        private processParams(params) {
            switch (params.action) {
                case Meevo.Components.Common.Messages.RETURN_FROM_WEB_MEEVO:
                    this.context.activate();
                default:
                    break;
            }
        }

    }
    angular.module("meevo.plugins.tippy")
        .controller("meevo.plugins.tippy.TippyController", TippyController);
}